export enum TransactionType {
  Sale = 'Sale',
  Refund = 'Refund',
}
